<script>
  // Jobs that failed, were killed, or were interrupted by a restart.
  import JobList from "./JobList.svelte";
  import ErrorCard from "../FileCard/ErrorCard.svelte";
</script>

<JobList
  url="/file/error"
  title="Error"
  emptyMessage="No failed jobs"
  emptyHint="Anything a script writes to stderr lands the job here."
  emptyIcon="fa-check-circle"
  let:file
  let:refresh
>
  <ErrorCard
    fileId={file.id}
    filename={file.file_name}
    uploadedDateTime={file.upload_date}
    errorMessage={file.error_message}
    on:changed={refresh}
  />
</JobList>
